import { useEffect } from 'react';

// Navigation policy (marketing request): main site links load each page as a full document
// (so GTM/GA fire their default Page View per page). Instant client-side navigation is kept
// only inside the blog and inside the admin.
export const softNavigationAllowed = (from, to) =>
  (from.startsWith('/blog') && to.startsWith('/blog')) || (from.startsWith('/admin') && to.startsWith('/admin'));

const HardNavigation = () => {
  useEffect(() => {
    const onClick = (e) => {
      if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      const a = e.target.closest('a[href]');
      if (!a || a.target === '_blank' || a.hasAttribute('download')) return;
      const url = new URL(a.href, window.location.href);
      if (url.origin !== window.location.origin) return;
      if (url.pathname === window.location.pathname && url.hash) return;
      if (softNavigationAllowed(window.location.pathname, url.pathname)) return;
      e.preventDefault();
      e.stopPropagation();
      window.location.assign(url.pathname + url.search + url.hash);
    };
    document.addEventListener('click', onClick, true);
    return () => document.removeEventListener('click', onClick, true);
  }, []);
  return null;
};

export default HardNavigation;
